import { RegistrationKiwiSaverStoreModule } from './registration-kiwisaver/registration-kiwisaver-store.module';
import { RegistrationStoreModule } from './registration/registration-store.module';
import { InvestorStoreModule } from './investor/investor-store.module';
import { UtilitiesStoreModule } from './utilities/utilities-store.module';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ClientStoreModule } from './client/client-store.module';
import { GeneralSelectionStoreModule } from './general-selection/general-selection-store.module';
import { TempPlannedPortfoliosStoreModule } from './planned-portfolios/temp-planned-portfolios-store.module';
import { PlannedPortfoliosStoreModule } from './planned-portfolios/planned-portfolios-store.module';
import { GlobalNotificationStoreModule } from './global-notification/global-notification-store.module';
import { UserStoreModule } from './user/user-store.module';
import { AuthStoreModule } from './auth/auth-store.module';
import { ModelPortfoliosStoreModule } from './model-portfolios/model-portfolios-store.module';
import { TransactionsStoreModule } from './transactions/transactions-store.module';
import { ReportsStoreModule } from './reports/reports-store.module';
import { PortfoliosStoreModule } from './portfolios/portfolios-store.module';
import { environment } from 'src/environments/environment';
import { AppEffects } from './app/app.effects';
import { appMetaReducers, appReducer } from './app/app.reducer';
import { SystemFacade } from './system/facade/system.facade';
import { TradingStoreModule } from './order/trading-store.module';
import { DocumentLibraryModule } from './document-library/document-library.module';
import { SystemLoaderStoreModule } from './system-loader/system-loader-store.module';
import { WithdrawalStoreModule } from './withdrawals/withdrawal-store.module';
import { NotificationStoreModule } from './notifications/notifications.module';
import { BankAccountModule } from './bank-account/bank-account.module';
import { TermDepositModule } from "./termDeposits/term-deposit.module";
import { ReinvestmentStoreModule } from "./order/facades/reinvestment-store.module";
import { LegalEntityInstructionModule } from './legal-entity-instructions/legal-entity-instruction.module';
import { RegularInvestmentPlanModule } from './regular-investment-plan/regular-investment-plan.module';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forRoot(appReducer, { metaReducers: appMetaReducers }),
    EffectsModule.forRoot([
      AppEffects
    ]),
    GlobalNotificationStoreModule,
    UserStoreModule,
    AuthStoreModule,
    GeneralSelectionStoreModule,
    ClientStoreModule,
    ModelPortfoliosStoreModule,
    TransactionsStoreModule,
    PortfoliosStoreModule,
    ReportsStoreModule,
    RegistrationStoreModule,
    RegistrationKiwiSaverStoreModule,
    UtilitiesStoreModule,
    InvestorStoreModule,
    TradingStoreModule,
    ReinvestmentStoreModule,  
    PlannedPortfoliosStoreModule,
    TempPlannedPortfoliosStoreModule,
    DocumentLibraryModule,
    LegalEntityInstructionModule,
    SystemLoaderStoreModule,
    WithdrawalStoreModule,
    NotificationStoreModule,
    BankAccountModule,
    TermDepositModule,  
    RegularInvestmentPlanModule,
    !environment.production ? StoreDevtoolsModule.instrument({connectInZone: true}) : [],
  ],
  providers: [SystemFacade]
})

export class RootStoreModule {
  constructor(@Optional() @SkipSelf() parentModule: RootStoreModule) {
    if (parentModule) {
      throw new Error('RootStoreModule is already loaded. Import in AppModule only.');
    }
  }

  static forRoot(): ModuleWithProviders<RootStoreModule> {
    return {
      ngModule: RootStoreModule,
      providers: []
    };
  }
}

